/* jshint browserify: true */
'use strict';

import $ from 'jquery';

export default class Renderer {
    constructor() {
        this.elementClassName = 'mathRenderer';
    }

    setMathConfiguration(mathElement, conf) {
        mathElement.setAttribute('data-math', JSON.stringify(conf));
    }

    render() {
        return $.Deferred();
    }

    elementsPreProcessor(elements) {
        return elements;
    }

    getMathConfiguration(mathElement) {
        const mathString = mathElement.getAttribute('data-math');
        return mathString ? JSON.parse(mathString) : {};
    }

    getMathFromElement(element) {
        const math = this.getMathConfiguration(element);
        math.latex = math.latex.trim();
        return math;
    }
}
